/**
 * @generated SignedSource<<792d9706ba29be37d7e8b676607831d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimilarAnswersSuggestions_answer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarAnswers_answer"
    }
  ],
  "type": "AnswerRichText",
  "abstractKey": null
};

node.hash = "b9f2762021f23874faddb8e71f4271b3";

module.exports = node;
